module.exports = __webpack_public_path__ + "static/media/small_logo.de6113cd.ico";